import { useQuery } from "@tanstack/react-query";
import { healthApi } from "@/lib/api";

export interface ServiceCheck {
  status: "ok" | "degraded" | "error" | "unknown" | "not_configured";
  latency_ms: number;
  detail: string;
}

export interface DetailedHealthResponse {
  overall: "ok" | "degraded" | "error";
  checks: Record<string, ServiceCheck>;
  timestamp: string;
}

export function useHealth(enabled = true) {
  return useQuery<DetailedHealthResponse>({
    queryKey: ["health", "detailed"],
    queryFn: () => healthApi.detailed(),
    enabled,
    refetchInterval: 30_000,
    staleTime: 20_000,
    retry: false,
  });
}
